(() => {
  const rail = document.querySelector('[data-related]');
  if (!rail) return;

  const url = rail.dataset.relatedUrl;
  if (!url) return;

  // Dawn's own version of this omitted product_id from the request, so the
  // endpoint had nothing to recommend against and the section rendered empty
  // on every product page. The id is required.
  fetch(url)
    .then((response) => (response.ok ? response.text() : null))
    .then((html) => {
      if (!html) return;

      const fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-related]');

      if (!fresh || !fresh.querySelector('.pcard')) return;

      rail.innerHTML = fresh.innerHTML;
      rail.hidden = false;
    })
    .catch(() => {
      /* an empty rail is the correct outcome when recommendations fail */
    });
})();
